/* eslint-disable react/jsx-wrap-multilines */

import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { translate } from 'loankeeper-common/helpers'
import Window from 'loankeeper-common/components/Window'
// @ts-ignore
import LKButton from 'shared/LKButton'

import { transCmd } from './translator'
import { AccountStatementModal } from '../AccountStatement'

const Footer: FC<{
  ID: string
  hash: string
  openContext?: string
  onRefresh: () => Promise<any>
}> = ({ ID, hash, openContext, onRefresh }) => {
  const history = useHistory()
  return (
    <Window.Footer
      actions={
        <>
          {openContext === 'modal' ? (
            <AccountStatementModal
              name="AccountStatement"
              ID={ID}
              hash={hash}
              title={translate(`${transCmd}_statement`)}
            />
          ) : (
            <LKButton
              alias="transactions"
              permission="ACC_STATEMENT_VIEW"
              onClick={() => history.push(`/secure/account/${ID}/statement/${hash}`)}
            />
          )}
        </>
      }
      sideActions={<LKButton alias="refresh" onClick={onRefresh} />}
    />
  )
}

export default Footer
